import { useState } from "react";
import TabsContent from "./TabsContent";
import TabsHeader from "./TabsHeader";

const Tabs = ({ tabItems }: any) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="min-h-[400px] flex flex-col mt-5">
      <TabsHeader
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabItems={tabItems}
      />
      <TabsContent data={tabItems[activeTab]?.content} />
    </div>
  );
};

export default Tabs;
